import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, greyMui, MOBILE_BREAKPOINT } from "@ryde/theme";

export const TopCalendarPanelStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "top-calendar-panel",
})`
  .pickers_container {
    gap: 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: 560px;
  }
`;

export const TopCalendarWrapperStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "top-calendar-wrapper",
})`
  display: flex;
  align-items: center;
  margin-inline-start: 30px;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-inline-start: 10px;
  }
`;

export const TopCalendarDatesPanelStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "top-calendar-dates-panel",
})`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${greyMui._900};
  gap: 1px;
  cursor: pointer;

  svg {
    margin-inline-start: 5px;
    margin-inline-end: 6px;
  }
`;

export const TopCalendarPickerStyled = styled.div.attrs<
  IStyledAttributes & { $dir: "ltr" | "rtl" }
>(props => ({
  "data-e2e": "top-calendar-picker",
  dir: props.$dir,
}))`
  position: relative;
  display: flex;
  flex-direction: column;
  -webkit-box-align: stretch;
  align-items: stretch;

  .TopCalendarPicker-Label {
    color: ${blueGreyMui._400};
    font-weight: 400;
    font-size: 12px;
    padding-bottom: 4px;
  }

  .TopCalendarPicker-TimeContainer {
    padding: 16.5px 14px;
    position: absolute;
    top: calc((12px * 1.15) + 4px);
    inset-inline-start: ${({ $dir }) => ($dir === "rtl" ? "116px" : "82px")};
    font-size: 16px;
    line-height: 1.4375;
    .TopCalendarPicker-Dash {
      padding-inline-start: 8px;
      color: ${blueGreyMui._300};
    }
    @media (max-width: ${MOBILE_BREAKPOINT}) {
      top: calc((12px * 1.15) + 4px);
    }
  }

  .MuiTypography-overline {
    display: none;
  }

  .MuiPickersInputBase-adornedEnd .MuiPickersSectionList-root {
    justify-content: flex-start;
  }
`;

export const TopCalendarArrowsStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "top-calendar-arrows",
})`
  margin-inline-start: 20px;
  display: flex;
  align-items: center;
  gap: 13px;
  svg {
    cursor: pointer;
  }
  /* TODO: Temporarily size until the final decision about calendar choice for mobile*/
  @media (max-width: 450px) {
    display: none;
  }
`;

export const TopCalendarPopperContent = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "top-calendar-popper-content",
})`
  padding-inline-start: 15px;
  padding-inline-end: 15px;
  padding-top: 15px;
`;

export const TopCalendarPopoverFooter = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "top-calendar-popover-footer",
})`
  padding: 12px;
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 9px;
`;

export const TopCalendarDateTimeTextStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "top-calendar-date-time-text",
  },
)`
  margin-top: 4px;
  font-size: 13px;
  display: flex;

  .date-time-wrapper {
    .date {
      padding-inline: 2.5px;
    }

    .revers-direction {
      display: inline-flex;

      .time-to {
        order: 3;
      }
      .dash {
        order: 2;
      }
      .time-from {
        order: 1;
      }
    }
  }

  .dash {
    color: ${blueGreyMui._300};
    margin-inline: 4px;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    .dash {
      margin-inline: 2px;
    }
  }
`;

export const TopCalendarDropdownStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "top-calendar-dropdown",
})`
  .MuiSelect-standard {
    padding-bottom: 0;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    & > .MuiInputBase-root {
      margin-inline-end: 3px;
    }
  }
`;

export const TopCalendarTimeStyled = styled.span.attrs<IStyledAttributes>({
  "data-e2e": "top-calendar-time",
})`
  padding-inline: 2.5px;
  color: ${blueGreyMui._300};
`;
